import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ENVIRONMENT } from '@interacta-shared/data-access-configuration';
import { map, Observable } from 'rxjs';
import {
    toBulkWorkflowTransitionOperation,
    toBulkWorkflowTransitionOperations,
} from '../models/bulk-workflow-transition.deserialize';
import { BulkWorkflowTransitionOperation } from '../models/bulk-workflow-transition.model';

@Injectable({
    providedIn: 'root',
})
export class BulkWorkflowTransitionService {
    private http = inject(HttpClient);

    private baseUrlData = `${inject(ENVIRONMENT).apiBasePath.common}/internal/v2/communication/posts`;

    public fetchBulkPostWorkflowOperations(
        operationId?: number,
        onlyUnread?: boolean,
        loadScreenData?: boolean,
    ): Observable<BulkWorkflowTransitionOperation[]> {
        return this.http
            .post(
                `${this.baseUrlData}/manage/get-massive-post-workflow-operation`,
                {
                    operationId,
                    onlyUnread,
                    loadScreenData,
                },
            )
            .pipe(map(toBulkWorkflowTransitionOperations));
    }

    public markBulkPostWorkflowOperationAsRead(
        operationId: number,
        read = true,
    ): Observable<void> {
        return this.http.put<void>(
            `${this.baseUrlData}/manage/massive-post-workflow-operations/${operationId}/read`,
            { read },
        );
    }

    public abortBulkPostWorkflowOperation(
        operationId: number,
        abort = true,
    ): Observable<BulkWorkflowTransitionOperation> {
        return this.http
            .put<{
                operation: BulkWorkflowTransitionOperation;
            }>(
                `${this.baseUrlData}/manage/massive-post-workflow-operations/${operationId}/abort`,
                { abort },
            )
            .pipe(
                map(({ operation }) =>
                    toBulkWorkflowTransitionOperation(operation),
                ),
            );
    }
}
